export default function Section({
  children,
  className = '',
  container = true,
  background = 'white',
  padding = 'normal',
}) {
  const backgroundClasses = {
    white: 'bg-white',
    neutral: 'bg-neutral-50',
    gray: 'bg-neutral-100',
  }

  const paddingClasses = {
    none: '',
    small: 'py-8',
    normal: 'py-12 md:py-16',
    large: 'py-16 md:py-24',
  }

  return (
    <section
      className={`${backgroundClasses[background]} ${paddingClasses[padding]} ${className}`}
    >
      {container ? (
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {children}
        </div>
      ) : (
        children
      )}
    </section>
  )
}
